import moment from "moment";
import xssEscape from "xss-escape";
import { default as api } from "../../api";
import { weekFormat, nl2br, sl2nbsp, notAllowEmptyObject, hasOwnProperty, isDateBetween } from "../../utils/lib";

export const mutations = {
    SET_TOKEN(state, payload) {
        if (!payload) return;
        state.token = payload;
    },

    // SET_AUTH_TOKEN(state, payload) {
    //     if (!payload) return;
    //     state.authToken = payload;
    // },

    // 구독학교 보기 개수 리밋 설정
    SET_LIMIT(state, payload) {
        state.limit = payload;
    },

    SET_USER(state, payload) {
        const { user, property, token } = payload;
        const { token: mobile_token, ...rest } = user;

        state.token = token;
        state.user = rest;
        state.unreadCount = property.unreadCount;
    },

    SET_LOGOUT(state) {
        localStorage.setItem("token", null);
        sessionStorage.setItem("token", null);

        state.token = null;
        state.user = {
            id: null,
            name: null,
            phoneNumber: null,
            userType: 0
        };
    },

    SET_RE_LOADING(state) {
        state.reLoading = !state.reLoading;
    },

    SET_CLEAR(state) {
        state.messages = [];
        state.page = 1;
        state.isLast = false;
    },

    SET_IS_LAST(state) {
        state.isLast = true;
    },

    SET_READ_MESSAGE(state) {
        state.unreadCount = 0;
    },

    SET_MESSAGE(state, payload) {
        const now = new Date(moment().format("YYYY/MM/DD")).getTime();

        const messages = payload.messageList.map(({ messageIdx, isRead, senderName, receiveDt, content, ...rest }) => {
            let etc = null,
                file = [],
                image = [],
                type = "message_light";

            if (hasOwnProperty(rest, "reply")) {
                etc = {
                    label: rest.reply.buttonLabel,
                    isResponded: rest.reply.isResponded,
                    replyUrl: hasOwnProperty(rest.reply, "replyUrl") ? rest.reply.replyUrl : null
                };

                type = rest.reply.buttonLabel === "링크로 이동하기" ? "message_light" : "survey_light";
            }

            if (hasOwnProperty(rest, "file")) {
                file = rest.file;
            }

            if (hasOwnProperty(rest, "image")) {
                image = rest.image;
            }

            const between = isDateBetween(now, receiveDt);
            const received_at = between || weekFormat(moment(receiveDt).format("|E요일 YYYY년 MM월 DD일"));

            const escapeContent = xssEscape(content);

            return {
                id: messageIdx,
                isRead,
                title: senderName,
                content: sl2nbsp(nl2br(escapeContent)),
                received_at,
                type,
                etc,
                file,
                image
            };
        });

        // append items
        state.messages = [...state.messages, ...messages];
    },

    SET_PAGE(state, payload) {
        state.page = payload;
    },

    SET_MESSAGE_LOADING(state) {
        state.messageLoading = !state.messageLoading;
    },

    SET_SCHOOLS(state, payload) {
        // payload = schoolList = []
        state.schools = payload;
    },

    SET_SCHOOLS_LOADING(state) {
        state.schoolsLoading = !state.schoolsLoading;
    },

    SET_PASSWORD_TOGGLE(state) {
        state.passwordToggle = !state.passwordToggle;
    }
};

export const actions = {
    // user 정보 및 기초적인 필요정보
    async GET_PROPERTY({ state, commit, dispatch }, { result, $alert, $router }) {
        commit("SET_SCHOOLS_LOADING");
        const { token, auto, hooks } = result;

        try {
            const params = notAllowEmptyObject({ token });
            const response = await api.user.getProperty(params);

            localStorage.setItem("auto", auto);

            if (auto) {
                localStorage.setItem("token", token);
            } else {
                sessionStorage.setItem("token", token);
                localStorage.setItem("token", null);
            }

            // 우선 user 정보만 넣고 있다.

            commit("SET_USER", { ...response.data, token });
            dispatch("GET_SCHOOL_LIST", { $alert, token, loading: false });

            $alert("success", "스쿨투게더에 오신것을 환영합니다.");
            $router.push("/");

            hooks(); // AuthPassword @logginToggle
        } catch (e) {
            commit("SET_SCHOOLS_LOADING"); // 오류시 loading 멈춤
            hooks(); // AuthPassword @logginToggle
            $alert("error", e.message);
        }
    },

    // 새로고침시 로직
    async GET_RE_PROPERTY({ state, commit, dispatch }, { token, $alert, $router }) {
        commit("SET_SCHOOLS_LOADING");

        try {
            const params = notAllowEmptyObject({ token });
            const response = await api.user.getProperty(params);

            // 우선 user 정보만 넣고 있다.
            commit("SET_USER", { ...response.data, token });
            dispatch("GET_SCHOOL_LIST", { $alert, token, loading: false });
            // $alert("success", "스쿨투게더의 재방문을 환영합니다.");
        } catch (e) {
            commit("SET_SCHOOLS_LOADING"); // 오류시 loading 멈춤
            $alert("error", e.message);
        }
    },

    async GET_SMS_MESSAGE({ state, commit }, { $alert }) {
        const { token, page } = state;

        commit("SET_MESSAGE_LOADING");

        try {
            const response = await api.user.getSmsMessages({ token, page });

            if (response.data.resultCode === 10003) {
                commit("SET_IS_LAST");
            } else {
                commit("SET_MESSAGE", response.data);
            }
            commit("SET_MESSAGE_LOADING");
        } catch (e) {
            commit("SET_MESSAGE_LOADING");
            $alert("error", e.message);
        }
    },

    async GET_SCHOOL_LIST({ state, commit }, { $alert, token, loading }) {
        if (loading) {
            commit("SET_SCHOOLS_LOADING");
        }

        try {
            const response = await api.user.getSchoolList({
                token: state.token || token
            });

            // empty = 10003
            commit("SET_SCHOOLS", response.data.resultCode === 10003 ? [] : response.data.schoolList);
            commit("SET_SCHOOLS_LOADING");
        } catch (e) {
            commit("SET_SCHOOLS_LOADING");
            $alert("error", e.message);
        }
    }
};
